import React, { useState, useEffect } from "react";
import { IDataResource } from "./type";
import { updateDrafResourceAction } from "../../../redux/actions/company-page-investor-action/my-investor-page-action";
import { rootState } from "../../../redux/reducers";
import { toast } from "react-toastify";

export default function UseEditResourceCtr(props: {
  initialProps: any;
  validate: (params: any) => void;
}) {
  const [isShowRessource, setIsShowRessource] = useState<boolean>(false);
  const [fileDataSource, setFileDataSource] = useState<Array<IDataResource>>(
    []
  );

  const [loader, setLoader] = useState<boolean>(false);

  const [isEdit, setisEdit] = useState<boolean>(false);

  const initialiseRessource = () => {
    let draftRessource = props?.initialProps?.filter(
      (el: any) => el?.draft === true
    );
    /**
     * Initialise draft with response value
     */
    let valueStoreResourceEdit = draftRessource?.map((el: IDataResource) => ({
      ...el,
      dataFile: "",
      isChange: false,
    }));
    setFileDataSource(valueStoreResourceEdit);
  };

  useEffect(() => {
    initialiseRessource();
    return () => {};
  }, [props?.initialProps]);

  const cbUpdateDraft = (data: any) => {
    setLoader(false);
    setIsShowRessource(false);
  };

  const saveUpdate = () => {
    setLoader(true);
    /**
     * get file object in file change
     */
    let fileChange = fileDataSource?.map((el: any) => el?.dataFile);
    /**
     *get data  change
     */
    let stringChange = fileDataSource?.map((el: any, index: number) => {
      if (el?.isChange === true) {
        return {
          id: el?.id,
          file: el?.dataFile != "" ? index : "",
        };
      }
    });

    //remove undefined data array
    let dataStringToSend = stringChange?.filter(
      (el: any) => el?.id && el?.id != undefined
    );

    let dataToSend = {
      ...fileChange,
      investorPageResources: JSON.stringify(dataStringToSend),
    };
    props?.validate(dataToSend);
  };

  const setFileResource = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: number
  ) => {
    const file = event?.target && event?.target?.files?.[0];
    if (file) {
      let fileName = file.name?.split(".").pop()?.toLowerCase();
      let fileSize = file.size;
      const isUpLimit = fileSize > 10500000;
      if (isUpLimit) {
        return toast("Max resources file size is 10 Mo ");
      }
      if (file) {
        const isInFileType =
          fileName === "pdf" ||
          fileName?.includes("doc") ||
          fileName?.includes("docx");
        if (isInFileType) {
          let tempFile: any = fileDataSource?.map(
            (el: IDataResource, t: number) => {
              if (el?.id?.toString() === id?.toString()) {
                return {
                  ...el,
                  dataFile: event?.target?.files?.[0],
                  file_name: event?.target?.files?.[0].name,
                  isChange: true,
                };
              } else {
                return {
                  ...el,
                };
              }
            }
          );
          setFileDataSource(tempFile);
        }
      }
    }
  };

  const removeFile = async (id: number, index: number) => {
    let tempData: any = fileDataSource?.map((el: IDataResource, i: number) => {
      if (el?.id == id) {
        return {
          id: el?.id,
          dataFile: "",
          isChange: true,
          file_name: "",
          file_location: "",
          draft: true,
        };
      } else {
        return el;
      }
    });
    setFileDataSource(tempData);
  };

  const showModalEditRessource = () => {
    setIsShowRessource(true);
  };

  const closeRessourceModal = () => {
    setIsShowRessource(false);
    setLoader(false);
    initialiseRessource();
  };

  return {
    isEdit,
    setisEdit,
    saveUpdate,
    fileDataSource,
    setFileResource,
    loader,
    setLoader,
    setIsShowRessource,
    removeFile,
    isShowRessource,
    showModalEditRessource,
    closeRessourceModal,
  };
}
